module.exports = __webpack_public_path__ + "img/500.fcccf37c.png";